import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AppIcon from '../AppIcon';
import FeedbackModal from './FeedbackModal';

interface Props {
  featureName: string;
  url?: string;
  size?: 'mini' | 'tiny' | 'small' | 'large' | 'big' | 'huge' | 'massive';
  color?: string;
  style?: React.CSSProperties;
  trigger?: React.ReactElement<{
    onClick?: React.MouseEventHandler;
    href?: string;
  }>;
}

const FeedbackButton: React.FC<Props> = ({
  featureName,
  url,
  size = 'small',
  color = 'orange',
  style,
  trigger,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const tooltip = t('FeedbackButtonTooltip');
  const defaultTrigger = (
    <AppIcon
      name="comment outline"
      size={size}
      color={color}
      aria-label={tooltip}
      title={tooltip}
      style={{
        ...style,
      }}
      onClick={handleButtonClick}
    />
  );

  const triggerElement = trigger
    ? React.cloneElement(trigger as React.ReactElement<any>, {
        onClick: (event: React.MouseEvent) => {
          trigger.props.onClick?.(event);
          handleButtonClick();
        },
        title: tooltip,
        ...(trigger.type === 'a' && !trigger.props.href
          ? {
              role: 'button',
              tabIndex: 0,
              onKeyDown: (event: React.KeyboardEvent) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleButtonClick();
                }
              },
            }
          : {}),
      })
    : defaultTrigger;

  return (
    <>
      {triggerElement}
      {isModalOpen && (
        <FeedbackModal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          featureName={featureName}
          url={url}
        />
      )}
    </>
  );
};

export default FeedbackButton;
